import { gql } from '@src/__generated__';

export const GET_ACTIVITY_AI_DETAILS = gql(`
  query ActivityAiDetails($tripProfileId: ID!, $activityName: String!) {
    getActivityAiDetails(tripProfileId: $tripProfileId, activityName: $activityName) {
      aiDetails
    }
  }
`);
